export const openedCoupCountrySet = new Set(['IN'])
export const home = {
  defalutBannerDesc: [
    {
      icon: 'iconziyuan',
      text_i18n: `p1_banner_desc1`
    },
    {
      icon: 'iconziyuan',
      text_i18n: `p1_banner_desc2`
    },
    {
      icon: 'iconziyuan',
      text_i18n: `p1_banner_desc3`
    },
    {
      icon: 'iconziyuan',
      text_i18n: `p1_banner_desc4`
    },
    {
      icon: 'iconziyuan',
      text_i18n: `p1_banner_desc5`
    }
  ]
}

const couponConfig = {
  IN: {
    amount_i18n: 'coupon_amount_in',
    name_i18n: 'coupon_name_in',
    country_i18n: 'only_country_tip_in'
  }
}

export const countryFacebookConfig = {
  IN: {
    link: 'https://www.facebook.com/TikTokForBusinessIndia'
  },
  JP: {
    link: 'https://www.facebook.com/TikTokForBusinessJP'
  },
  RU: {
    link: 'https://www.facebook.com/TikTokForBusinessRussia'
  },
  IL: {
    link: 'https://www.facebook.com/TikTokForBusinessIsrael'
  },
  KR: {
    link: 'https://www.facebook.com/TikTokForBusinessKorea'
  },
  other: {
    link: 'https://www.facebook.com/TikTokForBusiness'
  }
}
